import SeminarVideo from './SeminarVideo.component';

export default SeminarVideo;
